import base from '../httpApi/base'; // 导入接口域名列表
import axios from '../httpApi/http'; // 导入http中创建的axios实例

const adApi = {
    //获取广告商列表
    AdminBrandGetAll(params) {
        return axios.get(`${base.dev}/services/app/AdminBrand/GetAll`, { params })
    },
    AdminBrandGet(params) {
        return axios.get(`${base.dev}/services/app/AdminBrand/Get`, { params })
    },
    AdminBrandCreate(params) {
        return axios.post(`${base.dev}/services/app/AdminBrand/Create`, params)
    },
    AdminBrandUpdate(params) {
        return axios.put(`${base.dev}/services/app/AdminBrand/Update`, params)
    },
    AdminBrandDelete(params) {
        return axios.delete(`${base.dev}/services/app/AdminBrand/Delete`, { params: params })
    },

    getBannerTypeList(params) {
        return axios.get(`${base.dev}/services/app/AdminBanner/getBannerTypeList`, { params })
    }
    //#endregion
}
export default adApi


// WEBPACK FOOTER //
// ./src/api/ad/adApi.js